/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type SendBillingGroupRequestEmailMutationInput = {
    billingGroupId: string;
    clientMutationId?: string | null | undefined;
    orgRelayId: string;
    personId: string;
};
export type SendBillingGroupRequestEmailMutationVariables = {
    input: SendBillingGroupRequestEmailMutationInput;
};
export type SendBillingGroupRequestEmailMutationResponse = {
    readonly sendBillingGroupRequestEmail: {
        readonly clientMutationId: string | null;
    } | null;
};
export type SendBillingGroupRequestEmailMutation = {
    readonly response: SendBillingGroupRequestEmailMutationResponse;
    readonly variables: SendBillingGroupRequestEmailMutationVariables;
};



/*
mutation SendBillingGroupRequestEmailMutation(
  $input: SendBillingGroupRequestEmailMutationInput!
) {
  sendBillingGroupRequestEmail(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "SendBillingGroupRequestEmailMutationPayload",
            "kind": "LinkedField",
            "name": "sendBillingGroupRequestEmail",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientMutationId",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "SendBillingGroupRequestEmailMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "SendBillingGroupRequestEmailMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "b856de0e5071784004b7768192ad371c",
            "id": null,
            "metadata": {},
            "name": "SendBillingGroupRequestEmailMutation",
            "operationKind": "mutation",
            "text": "mutation SendBillingGroupRequestEmailMutation(\n  $input: SendBillingGroupRequestEmailMutationInput!\n) {\n  sendBillingGroupRequestEmail(input: $input) {\n    clientMutationId\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '6c18f2b8e940784d87a438fe6b023fc9';
export default node;
